export enum ESolarPlantGraphType {
  LIVE_FEED = "LIVE_FEED",
  CONSUMPTION = "CONSUMPTION",
  SOLAR_YIELD = "SOLAR_YIELD",
  GENERATOR = "GENERATOR",
  GRID = "GRID",
}
